//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      item: {
        title: this.$route.query.title,
        ctn: this.$route.query.ctn,
        time: this.$route.query.time,
        name: this.$route.query.name
      },
      form_up: {
        question_id: this.$route.query.id,
        name: JSON.parse(localStorage.getItem("wkt_login_peo")).stu_name,
        ctn: "",
        state: this.$route.query.state,
        dialog: false
      },
      toast: {
        dialog: false,
        text: ""
      },
      list_ary: [],
      loading: false
    };
  },
  mounted() {
    this.search();
    this.$nextTick(() => {
      this.$refs.answer.style.marginTop =
        parseInt(this.$refs.problem.offsetHeight) + 5 + "px";
    });
  },
  components: {},
  methods: {
    search: function() {
      this.loading = true;
      let formData = new FormData();
      formData.append("action_type", "get_stu_to_answer");
      formData.append("id", this.form_up.question_id);
      formData.append("orderByObj", "good_num");
      formData.append("orderBy", "desc");
      this.loading = true;
      this.$http({
        url: "/search/common.php",
        method: "post",
        data: formData
      }).then(res => {
        this.loading = false;
        this.list_ary = res.data.data;
      });
    },
    onSubmit() {
      //提交数据
      let re = /^[\u4E00-\u9FA5]+$/;
      if (this.form_up.content == "") {
        this.toast.dialog = true;
        this.toast.text = "请完善信息";
        return;
      }

      this.form_up.dialog = false;
      this.loading = true;
      this.$http
        .get("/upload/stu_upload.php", {
          params: {
            operate_type: "up_answer",
            question_id: this.form_up.question_id,
            state: this.form_up.state,
            name: this.form_up.name,
            ctn: this.form_up.content
          }
        })
        .then(res => {
          this.loading = false;
          this.toast.dialog = true;
          this.toast.text = res.data.info;
          if (res.data.status == 1) {
            this.form_up.content = "";
            this.search();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    add_good_num(obj) {
      console.log(obj);
      this.loading = true;
      this.$http
        .get("/upload/stu_upload.php", {
          params: {
            operate_type: "update_stu_good_num",
            id: obj.id,
            num: parseInt(obj.good_num) + 1
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == 1) {
            this.search();
          }

          this.toast.dialog = true;
          this.toast.text = res.data.info;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/online_answer/stu_to_answer.vue